/***************************
追従カートボタン - 表示切り替え
****************************/
//カートボタンが画面からいなくなったら、カートへ遷移ボタンを表示する
$(document).ready(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    $("#following-buttons").hide();
    var top = $(".product-form__buttons").offset().top;
    if ($(window).height() < top) {
      //最初に#btnBlockが見えてない場合
      $("#following-buttons").show();
    }
  }
});

$(window).scroll(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    var top = $(".product-form__buttons").offset().top;
    if ($(window).height() > top) {
      // 最初に#btnBlockが見えている場合
      if ($(window).scrollTop() > top) {
        $("#following-buttons").fadeIn();
      } else {
        $("#following-buttons").fadeOut();
      }
    } else {
      // 最初に#btnBlockが見えていない場合
      if (
        $(window).scrollTop() + $(window).height() > top &&
        $(window).scrollTop() < top
      ) {
        $("#following-buttons").fadeOut();
      } else {
        $("#following-buttons").fadeIn();
      }
    }
  }else {
    $("#following-buttons").fadeOut();
  }
});

/************************************
追従カートボタン - モーダル表示切り替え
*************************************/
//// 商品詳細 モーダルウィンドウ 
const buttonOpen = document.getElementById('modalOpen');
const modal = document.getElementById('addCartModal');
const buttonClose = document.getElementById('modalClose');

// ボタンがクリックされた時
if (buttonOpen){ 
buttonOpen.addEventListener('click', modalOpen);
}
function modalOpen() {
  modal.style.display = 'block';
}
// バツ印がクリックされた時
if (buttonClose){ 
buttonClose.addEventListener('click', modalClose);
}
function modalClose() {
  modal.style.display = 'none';
}
// モーダルコンテンツ以外がクリックされた時
addEventListener('click', outsideClose);
function outsideClose(e) {
  if (e.target == modal) {
    modal.style.display = 'none';
  }
}